"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CardSection", {
  enumerable: true,
  get: function get() {
    return _CardSection.default;
  }
});
exports.default = exports.StyledCard = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _CardWrapper = _interopRequireDefault(require("./components/CardWrapper"));

var _CardContext = require("./CardContext");

var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));

var _getSpacingToken = _interopRequireDefault(require("../common/getSpacingToken"));

var _Header = _interopRequireDefault(require("./components/Header"));

var _consts = require("../Heading/consts");

var _CardSection = _interopRequireDefault(require("./CardSection"));

var StyledCard = _styledComponents.default.div.withConfig({
  displayName: "Card__StyledCard",
  componentId: "ff0z2v-0"
})(["width:100%;box-sizing:border-box;position:relative;font-family:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.fontFamily;
}, _getSpacingToken.default); // $FlowFixMe: https://github.com/flow-typed/flow-typed/issues/3653#issuecomment-568539198


exports.StyledCard = StyledCard;
StyledCard.defaultProps = {
  theme: _defaultTheme.default
};

var Card = function Card(_ref2) {
  var title = _ref2.title,
      _ref2$titleAs = _ref2.titleAs,
      titleAs = _ref2$titleAs === void 0 ? _consts.ELEMENT_OPTIONS.H2 : _ref2$titleAs,
      icon = _ref2.icon,
      actions = _ref2.actions,
      description = _ref2.description,
      children = _ref2.children,
      dataTest = _ref2.dataTest,
      onClose = _ref2.onClose,
      loading = _ref2.loading,
      header = _ref2.header,
      spaceAfter = _ref2.spaceAfter,
      dataA11ySection = _ref2.dataA11ySection;

  var _React$useState = React.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      expandedSections = _React$useState2[0],
      setExpandedSections = _React$useState2[1]; // handles array of expanded sections


  var addSection = React.useCallback(function (index) {
    setExpandedSections(function (prev) {
      return prev.indexOf(index) === -1 ? [].concat((0, _toConsumableArray2.default)(prev), [index]) : prev;
    });
  }, []);
  var removeSection = React.useCallback(function (index) {
    setExpandedSections(function (prev) {
      return prev.indexOf(index) !== -1 ? prev.filter(function (val) {
        return val !== index;
      }) : prev;
    });
  }, []); // Currently disable that code, becuase of IE 11, where it does not work
  // It will be fixed later, when we'll find solution
  // eslint-disable-next-line no-unused-vars

  var renderSection = function renderSection(item, index) {
    if ( /*#__PURE__*/React.isValidElement(item)) {
      // if (item.props.children && item.type.name !== "CardSection") {
      //   return React.createElement(CardSection, {
      //     ...item.props.children.props,
      //     key: index,
      //   });
      return /*#__PURE__*/React.cloneElement(item);
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(StyledCard, {
    spaceAfter: spaceAfter,
    "data-test": dataTest
  }, (title || header) && !loading && /*#__PURE__*/React.createElement(_CardWrapper.default, {
    bottomBorder: !children || expandedSections.some(function (val) {
      return val === 0;
    })
  }, /*#__PURE__*/React.createElement(_Header.default, {
    icon: icon,
    description: description,
    dataA11ySection: dataA11ySection,
    actions: actions,
    title: title,
    titleAs: titleAs,
    onClose: onClose,
    header: header
  })), children ? React.Children.map(children, function (item, key) {
    if (!item) return null;
    var topRoundedBorder = expandedSections.indexOf(key - 1) !== -1 || expandedSections.indexOf(key) !== -1;
    var bottomRounderBorder = expandedSections.indexOf(key + 1) !== -1 || expandedSections.indexOf(key) !== -1; // This is used for the case when user wants to map sections and change their order
    // related issue: #1005

    var index = Number(item.key) || key;
    return /*#__PURE__*/React.createElement(_CardContext.Provider, {
      value: {
        addSection: addSection,
        removeSection: removeSection,
        roundedBorders: {
          top: topRoundedBorder,
          bottom: bottomRounderBorder
        },
        index: index,
        noBorderTop: index === 0 && Boolean(title),
        isOpened: expandedSections.some(function (val) {
          return val === index;
        })
      }
    }, loading ? /*#__PURE__*/React.createElement(_CardWrapper.default, {
      noPadding: true
    }, /*#__PURE__*/React.createElement(_Loading.default, {
      loading: loading,
      type: "boxLoader"
    }, renderSection(item, index))) : renderSection(item, index));
  }) : null);
};

var _default = Card;
exports.default = _default;